import * as logging from 'utils/Logging'

import { useState } from 'react'

import { borrowerPublicApiClient } from 'api/BorrowerPublicApiClient'

interface Props {
  intermediaryApiName: string | undefined
  canQuote: boolean
  fetchIntermediaryData: (intermediaryHash: string | undefined) => void
  hasIntermediaryDataError: boolean
}

const UseApiRequest = (): Props => {
  const borrowerPublicApi = borrowerPublicApiClient()
  const [intermediaryApiName, setIntermediaryApiName] = useState<string | undefined>(undefined)
  const [canQuote, setCanQuote] = useState<boolean>(false)
  const [hasIntermediaryDataError, setHasIntermediaryDataError] = useState<boolean>(false)

  const fetchIntermediaryData = (intermediaryHash: string | undefined) => {
    borrowerPublicApi.getIntermediaryDataResponse(intermediaryHash).then(
      (res) => {
        setIntermediaryApiName(res.intermediaryApiName)
        setCanQuote(res.intermediaryCanQuote)
      },
      (error) => {
        logging.logError('failed to get intermediary data', error)
        setHasIntermediaryDataError(true)
        setIntermediaryApiName(undefined)
      },
    )
  }

  return {
    intermediaryApiName,
    canQuote,
    fetchIntermediaryData,
    hasIntermediaryDataError,
  }
}

export default UseApiRequest
